import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type Worker } from "@src/appV2/Worker/api/types";

import { ShiftBlockFilter } from "./components/ShiftBlockFilter";
import { ShiftBlocks } from "./components/ShiftBlocks";

interface ShiftBlockPageProps {
  agent: Worker;
  facilityId?: string;
  orientationBlockQualification?: string;
}

interface ShiftBlockPageHeaderProps {
  agent: Worker;
  orientationBlockQualification?: string;
}

function ShiftBlockPageHeader(props: ShiftBlockPageHeaderProps) {
  const { agent, orientationBlockQualification } = props;
  const isOrientationBlock = isDefined(orientationBlockQualification);

  if (!isOrientationBlock && agent.licensesData.length <= 1) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
      {isOrientationBlock ? (
        <Text>Orientation Blocks for {orientationBlockQualification}</Text>
      ) : (
        <>
          <Text>Block for</Text> <ShiftBlockFilter worker={agent} />
        </>
      )}
    </Stack>
  );
}

export function ShiftBlockPage(props: ShiftBlockPageProps) {
  const { agent, facilityId, orientationBlockQualification } = props;

  return (
    <Stack sx={{ overflowY: "auto", p: 2 }} flex={1} spacing={2}>
      <ShiftBlockPageHeader
        agent={agent}
        orientationBlockQualification={orientationBlockQualification}
      />
      <ShiftBlocks
        worker={agent}
        facilityId={facilityId}
        orientationBlockQualification={orientationBlockQualification}
      />
    </Stack>
  );
}
